module.exports = __webpack_public_path__ + "media/svg-new/like-5ec30f4f.svg";